"use client";

import { Button } from "@heroui/react";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const tMessages = useTranslations("messages");
  const tButtons = useTranslations("buttons");

  useEffect(() => {
    // Keep console logging for local debugging and external error capture hooks.
    /* eslint-disable no-console */
    console.error(error);
  }, [error]);

  return (
    <section className="container mx-auto flex min-h-[40vh] flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <h2 className="font-kufi text-primary-700 text-2xl dark:text-white">
        {tMessages("error occurred")}
      </h2>
      <p className="text-muted max-w-xl text-sm leading-7">
        {error.message || tMessages("error occurred")}
      </p>
      <Button
        className="bg-primary-700 dark:text-primary text-white dark:bg-white"
        onPress={reset}
      >
        {tButtons("continue")}
      </Button>
    </section>
  );
}
